import { Breakpoint, useMediaQuery, useTheme } from '@mui/material'

export const useIsSmaller = (breakpoint: Breakpoint) => {
  const theme = useTheme()
  const threshold = theme.breakpoints.values[breakpoint]
  const defaultMatches =
    typeof window !== 'undefined' && threshold !== undefined
      ? window.innerWidth < threshold
      : false

  return useMediaQuery(theme.breakpoints.down(breakpoint), {
    noSsr: true,
    defaultMatches,
  })
}
